export function validateOrderData(data, type) {
  // Discount
  if (data.discount?.error) {
    return {
      detail: 'Check the discount code',
      type: 'discount',
    }
  }

  // Items
  if (!data.items?.length) {
    return {
      detail: 'You need to add at least one item to the checkout',
      type: 'items',
    }
  }

  // Contact and delivery
  if (type === 'order') {
    if (data.delivery.type === 'dispatch' && !data.delivery.address) {
      return {
        detail: 'Select delivery location',
        type: 'delivery',
      }
    }

    if (!data.contact?.phoneNumber) {
      return {
        detail: 'Provide a phone number',
        type: 'phone',
      }
    }
  } else {
    // it's a checkout
    if (
      data.checkoutPermissions.delivery !== 'edit' &&
      data.delivery.type === 'dispatch' &&
      !data.delivery.address
    ) {
      return {
        detail: 'Select delivery location',
        type: 'delivery',
      }
    }
  }

  return null
}
